import { render, staticRenderFns } from "./DashboardKPIs.vue?vue&type=template&id=64809933&scoped=true&"
import script from "./DashboardKPIs.vue?vue&type=script&lang=js&"
export * from "./DashboardKPIs.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DashboardKPIs.vue?vue&type=style&index=0&id=64809933&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "64809933",
  null
  ,true
)

export default component.exports